import { jsx, jsxs } from 'react/jsx-runtime';
import { Box } from '@vp/swan';
import 'react';
import { ErrorBoundary } from '../../../../configs/ErrorBoundary.js';
import { DefaultError } from '../../../../@core/components/errors/DefaultError.js';
import { Header } from '../../layout/Header.js';
import { Content } from '../../layout/Content.js';

const OrderReplacementFeature=({isModal})=>{return jsx(ErrorBoundary,{feature:"Order Replacement",fallback:jsx(DefaultError,{}),children:jsxs(Box,{"data-cy":"order-replacement-feature",children:[jsx(Header,{isModal:isModal}),jsx(Content,{})]})})};

export { OrderReplacementFeature };
//# sourceMappingURL=OrderReplacementFeature.js.map
